"use client";

import { usePathname } from "next/navigation";
import Image from "@/components/Image";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
// import { DeviceType, getDeviceTypeByUA } from "@/app/utils";

const NavBar = () => {
  const pathname = usePathname();
  const [activeNav, setActiveNav] = useState("/");
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const router = useRouter();
  // const [deviceType, setDeviceType] = useState<DeviceType>(DeviceType.OTHER);
  const [deviceType, setDeviceType] = useState<string>("other");

  const navs = [
    { name: "首页", path: "/" },
    { name: "产品与服务", path: "#tab-section" },
    {
      name: "付费校园版",
      path: "/xy",
      external: true,
      sameWindow: true,
    },
    {
      name: "代理合作",
      path: "https://mifengjiaoyu.feishu.cn/share/base/form/shrcng2mebO4szvD0RIF6nQYbmb?prefill_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=0%25+%E5%85%AC%E6%B5%B7&hide_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=1",
      external: true,
    },
  ];
  // 在组件挂载时获取设备类型
  useEffect(() => {
    import("current-device").then((module) => {
      const deviceType = module.default.type;
      setDeviceType(deviceType);
      if (deviceType === "desktop") {
        setDeviceType("pc");
      }
      if (deviceType === "unknown") {
        setDeviceType("other");
      }
    });
  }, []);
  // 处理导航点击事件
  const handleNavClick = (
    path: string,
    external?: boolean,
    sameWindow?: boolean,
  ) => {
    setActiveNav(path);

    // 如果是移动端，点击导航项后关闭菜单
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }

    // 处理外部链接
    if (external) {
      if (sameWindow) {
        window.open(path, "_self"); // 在当前页面打开
      } else {
        window.open(path, "_blank"); // 在新标签页打开
      }

      return;
    }

    // 处理首页链接，如果已经在首页则滚动到顶部，否则导航到首页
    if (path === "/") {
      // 检查当前是否在首页
      if (window.location.pathname === "/" || window.location.pathname === "") {
        // 已经在首页，只需滚动到顶部
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        // 不在首页，需要导航到首页
        window.location.href = "/";
      }
      return;
    }

    // 处理锚点滚动
    if (path.startsWith("#")) {
      const targetId = path.substring(1);

      // 检查当前是否在首页
      if (window.location.pathname === "/" || window.location.pathname === "") {
        // 已经在首页，直接滚动到锚点
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const offset = 88; // 偏移量（px）

          const targetPosition = targetElement.getBoundingClientRect().top;
          const scrollPosition = window.pageYOffset + targetPosition - offset;

          window.scrollTo({
            top: scrollPosition,
            behavior: "smooth",
          });
        }
      } else {
        // 不在首页，使用 Next.js 路由导航到首页+锚点
        router.push("/" + path);
      }
    }
  };

  // 处理Logo点击事件 - 返回顶部
  const handleLogoClick = () => {
    // 检查当前是否在首页
    if (window.location.pathname === "/" || window.location.pathname === "") {
      // 如果有 hash，去掉 hash
      if (window.location.hash) {
        history.replaceState(null, "", "/");
      }
      setActiveNav("/"); // 手动激活首页
      // 已经在首页，只需滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      // 不在首页，需要导航到首页
      window.location.href = "/";
    }
    return;
  };

  // 切换移动端菜单
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // 监听滚动事件
  useEffect(() => {
    const homeElement = document.getElementById("home-section");

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // 如果Home组件存在，检查是否滚动到了Home组件结束位置
      if (homeElement) {
        const homeHeight = homeElement.offsetHeight;

        // 如果滚动位置超过Home组件高度，隐藏导航栏
        if (currentScrollY > homeHeight + 2) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // 检测屏幕宽度变化
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(document.documentElement.clientWidth <= 1080);
    };

    // 初始检查
    checkIfMobile();

    // 监听窗口大小变化
    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  useEffect(() => {
    const setActiveByHash = () => {
      if (window.location.pathname === "/" && window.location.hash) {
        setActiveNav(window.location.hash);
      } else {
        setActiveNav(window.location.pathname);
      }
    };

    setActiveByHash();

    window.addEventListener("hashchange", setActiveByHash);
    window.addEventListener("popstate", setActiveByHash);

    return () => {
      window.removeEventListener("hashchange", setActiveByHash);
      window.removeEventListener("popstate", setActiveByHash);
    };
  }, [pathname]);

  return (
    <>
      <header
        className={`flex w-full min-h-[90px] px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] bg-white mx-auto 
         fixed top-0 left-0 right-0 z-50 transition-transform duration-300 items-center justify-center
         ${isVisible ? "translate-y-0" : "-translate-y-full"}`}
      >
        <div className="flex w-full max-w-[1360px] flex-row justify-between py-3">
          {/* Logo 区域 - 两个div */}
          <div
            className="flex w-full max-w-[277.97px] items-center mb-0 cursor-pointer"
            onClick={handleLogoClick}
          >
            {/* 蜜蜂家校div */}
            <div className="flex items-center justify-between w-auto h-auto flex-row">
              {/* 左侧部分 - 裁剪图片左半部分 */}
              <div className="max-w-[32px] h-auto">
                <Image
                  src="/logobee1_01.png"
                  alt="LogoBee Left"
                  width={32}
                  height={32}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* 右侧部分 - 裁剪图片右半部分 */}
              <div className="max-w-[102px] h-auto">
                <Image
                  src="/logobee2_01.png"
                  alt="LogoBee Right"
                  width={102}
                  height={46}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            {/* 分隔线 */}
            <div className="h-[14px] border-l border-black/10 mx-1"></div>
            {/* 扫描全能王div */}
            <div className="flex items-center  w-auto h-auto">
              <Image
                src="/logo_sacn_01.png"
                alt="LogoScan"
                width={119.97}
                height={18}
                className="w-[90px] sm:w-[100px] md:w-[119.97px] h-auto"
              />
            </div>
          </div>

          {/* 移动端菜单按钮 */}
          {isMobile && (
            <button
              className="flex flex-col justify-center items-center z-50"
              onClick={toggleMobileMenu}
              aria-label={isMobileMenuOpen ? "关闭菜单" : "打开菜单"}
            >
              {isMobileMenuOpen ? (
                // 关闭图标 (X)
                <div className="relative w-6 h-6">
                  <span className="absolute top-1/2 left-0 w-6 h-0.5 bg-[#212121] transform -rotate-45"></span>
                  <span className="absolute top-1/2 left-0 w-6 h-0.5 bg-[#212121] transform rotate-45"></span>
                </div>
              ) : (
                // 三线菜单图标
                <div className="flex flex-col justify-between max-w-[24px] h-[20px]">
                  <span className="w-[24px] h-0.5 bg-[#212121]"></span>
                  <span className="w-[24px] h-0.5 bg-[#212121]"></span>
                  <span className="w-[24px] h-0.5 bg-[#212121]"></span>
                </div>
              )}
            </button>
          )}

          {/* 桌面端导航 */}
          {!isMobile && (
            <div className="flex flex-row max-w-[724px] w-full">
              <nav className="flex flex-row w-full max-w-[547px] items-center justify-center px-[clamp(0px,2vw,32px)] gap-[clamp(0px,2vw,32px)]">
                {navs.map((nav) => (
                  <a
                    key={nav.path}
                    href={nav.path}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(nav.path, nav.external, nav.sameWindow);
                      window.Log.action("top_tab_click", {
                        top_tab: `${nav.name}`,
                        user_access_port: deviceType,
                      });
                    }}
                    className={`relative rounded-full py-[12px] px-[16px] text-[16px] transition-colors text-[#333333] hover:bg-gray-100 ${
                      activeNav === nav.path ? "font-bold" : "font-normal"
                    }`}
                  >
                    {nav.name}
                    {activeNav === nav.path && (
                      <div className="absolute left-1/2 transform -translate-x-1/2 w-[28px] top-[70%] mt-2 flex justify-center">
                        <Image
                          src="/Group_01.png"
                          alt="激活指示器"
                          width={28}
                          height={12}
                          className="w-full object-contain"
                        />
                      </div>
                    )}
                  </a>
                ))}
              </nav>
              {/* 登录按钮 */}
              <div className="flex items-center justify-end w-full max-w-[177px]">
                <a
                  href="https://xy.mifengjiaoyu.com/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex mt-2 sm:mt-0 sm:ml-3 md:ml-4 lg:ml-6 py-1 sm:py-1.5  w-[77px] h-[50px] bg-[#1dba55] text-white text-[16px] rounded-[6px] font-medium cursor-pointer items-center justify-center"
                  onClick={() => {
                    window.Log.action("login_click", {
                      user_access_port: deviceType,
                    });
                  }}
                >
                  登录
                </a>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* 移动端下拉菜单 */}
      {isMobile && isMobileMenuOpen && (
        <div className="fixed w-full  top-[70px] bg-white z-200 shadow-md pt-[50px] pb-[50px] items-center">
          <nav className="flex w-full flex-col justify-between items-center gap-[50px]">
            {navs.map((nav) => (
              <a
                key={nav.path}
                href={nav.path}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(nav.path, nav.external, nav.sameWindow);
                  window.Log.action("top_tab_click", {
                    top_tab: `${nav.name}`,
                    user_access_port: deviceType,
                  });
                }}
                className={`w-full text-center leading-[44px] font-[600] text-[24px]  text-black ${
                  activeNav === nav.path ? "font-bold" : ""
                }`}
              >
                {nav.name}
              </a>
            ))}
            {/* 移动端登录按钮 */}
            <a
              href="https://xy.mifengjiaoyu.com/login"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full text-center leading-[44px] font-[600] text-[24px]  text-black"
              onClick={() => {
                window.Log.action("login_click", {
                  user_access_port: deviceType,
                });
              }}
            >
              登录
            </a>
          </nav>
        </div>
      )}

      {/* 添加占位符，防止内容被固定导航栏覆盖 (仅在桌面端显示) */}
      <div className="h-[90px]"></div>
    </>
  );
};

export default NavBar;
